import { Component } from '@angular/core';
import { DEFAULT_URL } from '@app/app.constant';
import { AuthenticationService } from '@app/core/services/auth.service';
import { Project } from '@app/models/project/project.model';
import { LicenseService } from '@app/services/license/license.service';
import { ProjectService } from '@app/services/project/project.service';
import { onErrorAlert } from 'common/helper';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-menu-project-license-list',
  templateUrl: './menu-project-license-list.component.html',
  standalone: false
})
export class MenuProjectLicenseListComponent {

  public projectList: Project[] = [];
  public selectedProject: Project;

  private subs = new Subscription();

  constructor(
    public licenseService: LicenseService,
    private alert: ToastrService,
    private authService: AuthenticationService,
    private projectService: ProjectService
  ) { }

  ngOnInit() {
    // Assigned set = primary + additional projects (admins get all / all-in-licence). This is what
    // the user may switch their active project between; it does not change their primary project.
    const sub = this.projectService.getMyAssignedProjects().subscribe({
      next: (project) => {
        this.projectList = project;
        const selectedId = this.authService.currentUser?.projectId;
        if (selectedId) {
          this.selectedProject = this.projectList.find(item => item.id === selectedId);
        }
        if (!this.selectedProject) {
          this.selectedProject = this.projectList[0];
        }
      },
      error: (e) => {
        onErrorAlert(this.alert, e);
      },
    });

    this.subs.add(sub);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  selectionChanged = (projectId: number) => {
    if (projectId) {
      const projects = this.authService
        .changeProject(projectId)
        .subscribe({
          next: () => {
            // One full page load rather than router.navigate + reload — see the matching
            // comment in menu-license-list.component.ts. The project, like the licence, is
            // server-side session state, so the whole app has to be rebuilt; navigating first
            // just loaded the dashboard's data and threw it away, leaving aborted requests
            // behind. Landing on DEFAULT_URL avoids reloading a deep link from the old project.
            window.location.href = `/${DEFAULT_URL}`;
          },
          error: (e) => onErrorAlert(this.alert, e),
        });
      this.subs.add(projects);
    }
  }
}
